import { HistogramConfigurationProviderProps } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { HistogramPanelData } from 'features/drilldown/components/histogram/DrilldownHistogram'

const LATEST_DATA_SCHEMA_VERSION = 5

export const DEFAULT_INDICATION_DAMAGE_MECHANISM_HISTOGRAM_PANEL_DATA: HistogramPanelData =
  {
    panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
    title: 'Indication Damage Mechanisms',
    isPinned: true,
    selectedBarIds: [],
    groupingColumn: 'indication.detail.damage_mechanism',
    aggregationColumn: 'indication.id',
    aggregationOperation: 'count',
  }

export const INDICATION_DAMAGE_MECHANISM_HISTOGRAM_CONFIG_PROPS: HistogramConfigurationProviderProps =
  {
    defaultPanelData: DEFAULT_INDICATION_DAMAGE_MECHANISM_HISTOGRAM_PANEL_DATA,
    latestDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  }
